import { Theme } from '@mui/material'

const useStyles = {
  container: (theme: Theme) => ({
    minHeight: 'calc(100vh - 150px - 16px)',
    marginTop: `calc(${theme.spacing(2)} + 150px)`,
    [theme.breakpoints.up('md')]: {
      minHeight: 'calc(100vh - 103px - 103px - 150px)',
      marginTop: '150px',
    },
  }),
  mainContainer: {
    gap: 5,
    flexDirection: 'column',
    alignItems: 'center',
  },
  mainContainerWithMargin: (acknowledgeType: string) => ({
    gap: 5,
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: acknowledgeType === 'ack' ? 0 : '68px',
  }),
  headerContainer: {
    gap: 3,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  headerTitle: {
    fontWeight: '300',
  },
  helpStepsContainer: {
    flexDirection: 'column',
    gap: 1,
    paddingX: 3,
  },
  helpStepsTitle: {
    fontWeight: '500',
    textAlign: 'center',
  },
  pauseButtonContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    gap: theme.spacing(2),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  pauseButtonContent: {
    flex: '1',
    gap: '6px',
    textAlign: 'left',
  },
  loadingContainer: {
    justifyContent: 'center',
  },
  needHelpButtonContainer: {
    marginBottom: 5,
  },
  confirmationAnimation: {
    width: '48px',
    height: '44px',
    justifySelf: 'center',
  },
  bulletList: {
    margin: 0,
    paddingLeft: '16px',
  },
}

export default useStyles
